module.exports = __webpack_public_path__ + "../resources/img/new_sprite.60c0c8af.png";